import { maybe } from "@saleor/misc";

import { IFilterElement } from "../../../../components/Filter";
import {
  createFilterTabUtils,
  createFilterUtils,
  dedupeFilter,
  getMultipleValueQueryParam
} from "../../../../utils/filters";
import {
  BrandVerticalsFilterKey,
  BrandVerticalsFilterOpts
} from "../../components/BrandVerticalListPage/filters";
import {
  BrandVerticalListUrlFilters,
  BrandVerticalListUrlFiltersEnum,
  BrandVerticalListUrlFiltersWithMultipleValues,
  BrandVerticalListUrlQueryParams
} from "../../url";
export const BRAND_VERTICAL_FILTERS_KEY = "BrandVerticalFilter";

export function getFilterOpts(
  params: BrandVerticalListUrlFilters
): BrandVerticalsFilterOpts {
  return {
    brandStatus: {
      active: !!params.brandStatus,
      value: maybe(() => dedupeFilter(params.brandStatus), [])
    },
    vertical: {
      active: !!params.vertical,
      value: maybe(() => dedupeFilter(params.vertical), [])
    }
  };
}

export function getFilterVariables(params: BrandVerticalListUrlFilters) {
  return {
    brandStatus: maybe(() => params.brandStatus, null),
    search: params.query,
    vertical: maybe(() => params.vertical, null)
  };
}

export function getFilterQueryParam(
  filter: IFilterElement<BrandVerticalsFilterKey>
): BrandVerticalListUrlFilters {
  const { name } = filter;

  switch (name) {
    case BrandVerticalsFilterKey.brandStatus:
      return getMultipleValueQueryParam(
        filter,
        BrandVerticalListUrlFiltersWithMultipleValues.brandStatus
      );
    case BrandVerticalsFilterKey.vertical:
      return getMultipleValueQueryParam(
        filter,
        BrandVerticalListUrlFiltersWithMultipleValues.vertical
      );
  }
}

export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<BrandVerticalListUrlFilters>(
  BRAND_VERTICAL_FILTERS_KEY
);

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  BrandVerticalListUrlQueryParams,
  BrandVerticalListUrlFilters
>({
  ...BrandVerticalListUrlFiltersEnum,
  ...BrandVerticalListUrlFiltersWithMultipleValues
});
